import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton, CTooltip } from '@coreui/react'
import { Info, Trash, Trash2 } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import ProvidertsPoaBaseline from './ProvidertsPoaBaseline'
import ProviderHistoryofdiagnosisTs from './ProviderHistoryofdiagnosisTs'
import ProviderRiskFactors from './ProviderRiskFactors'
import ProviderAlert from './ProviderAlert'
import Providertsimagings from './Providertsimagings'
import ProviderPatientLabsTreatments from './ProviderPatientLabsTreatments'
import PatientIncidentGlobal from './PatientIncidentGlobal'
import PatientIncidentTreatments from './PatientIncidentTreatments'
import ProviderTreatmentPatientDifferentDiagnosis from './ProviderTreatmentPatientDifferentDiagnosis'
import ProviderShellAssessment from './ProviderShellAssessment'
import ProviderTreatmentPlans from './ProviderTreatmentPlans'
import SaveExtra from './../../services/general/saveExtraData.api'
import ProviderMobilityTreatment from './ProviderMobilityTreatment'
import ProviderMorseCodeTreatment from './ProviderMorseCodeTreatment'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderPatientTreatmentShell = ({
  patientDiagnosis,
  setActiveTabPatientInfo,
  saveTreatsShell,
  patientID,
  showDataIfNoteIsFollowUp = false,
  setAllLabs,
  patientTreatments,
  noteID,
  noteStructureRef,
  isAllotedToProvider = true,
  riskFactorWithKeyword,

  targetRef,
  selectedRisks,
  statusPatientNote,
  setSelectedRisks,
  diagnosisCode,
  allLabs,
  toPDF,
  MasterDiagnosisData,
  patientData,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  imagingTypeList,
  GetMasterMedications,
  masterMedications,
  setMasterMedications,
  hospitalRecords,
  setHospitalRecords,
  diagnosisAddedPinger,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  selectedDifferentialDiagnosis,
  setSelectedDifferentialDiagnosis,
  showComment,
  updatePatientDiagnosis,
  editPatientDiagnosis,
  deletePatientDiagnosis,
  updateNoteStructure,
  patientDBData,
  setPatientDBData,
  changesInTreatmentShell,
  setChangesInTreatmentShell,
  loggedUserProvider,
  noteCallType
}) => {
  console.log("noteCall Tyte shell treatment", noteCallType)
  const [noteRefTrigger, setNoteRefTrigger] = useState(0)

  const [bimsScoreData, setBimsScoreData] = useState({})
  const [diagnosisLabMap, setDiagnosisLabMap] = useState({})
  const [addedNewIncident, setAddedNewIncident] = useState(false)
  const [addedChangesToAssessment, setAddedChangesToAssessment] = useState(false)

  useEffect(() => {
    const bimsScores = noteStructureRef?.current?.BIMSScore
    setBimsScoreData(bimsScores)
  }, [noteStructureRef?.current?.BIMSScore])

  const getDiagnosisMedicationInRisk = (diagnosisName) => {
    if (masterMedications.length > 0) {
      const lastMedicationAdded = medication[medication.length - 1]
      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded
      const matchingDiagnoses = data.map((med) => {
        const matchingMasterMed = masterMedications.find((item) => item.Data.name === med.name)
        return matchingMasterMed
      })
      let name
      matchingDiagnoses.find((item) => {
        if (item?.Data.diagnoses.includes(diagnosisName)) {
          name = item.Data
        }
      })
      return name
    } else {
      return 'Not enough information'
    }
  }

  const renderValue = (value, key) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return null
    }

    if (Array.isArray(value)) {
      return value.join(', ')
    } else if (typeof value === 'string') {
      if (value.trim() === '') return null

      if (key.toLowerCase().includes('date')) {
        const dateParts = value.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/)
        if (dateParts) {
          const [_, month, day, year] = dateParts
          return `${month}/${day}/${year}`
        }
      }

      return value
    } else if (typeof value === 'object' && value !== null) {
      const entries = Object.entries(value).filter(([childKey, childValue]) => {
        const isEmpty = !childValue || (Array.isArray(childValue) && childValue.length === 0) || (typeof childValue === 'string' && childValue.trim() === '')
        return !isEmpty
      })

      if (entries.length === 0) return null

      return (
        <div className="d-flex flex-column">
          {entries.map(([childKey, childValue], idx) => {
            const rendered = renderValue(childValue, childKey)
            if (!rendered) return null
            return (
              <div key={idx} className="d-flex gap-2">
                <b style={{ textTransform: 'capitalize' }}>{childKey}:</b>
                <span>{rendered}</span>
              </div>
            )
          })}
        </div>
      )
    }

    return ''
  }

  const { getGeneralPlanStatement } = useIndexedDB()
  const [allTreamentStatements, setAllTreatmentStatements] = useState([])
  const getTreatmentPlansData = async () => {
    try {
      const datas = await getGeneralPlanStatement()
      console.log('general examination data', datas)
      setAllTreatmentStatements(datas)
    } catch (err) {
      console.error('Error fetching from IndexedDB:', err)
    }

    // let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
    // data = JSON.parse(data.d)?.Data || [];
    // if (data) {
    //     data = data?.map((item) => {
    //         return {
    //             Id: item.Id,
    //             Data: JSON.parse(item?.JsonData)
    //         }
    //     })
    // }
    // console.log('general plan statements', data)
    // setAllTreatmentStatements(data)
  }

  useEffect(() => {
    getTreatmentPlansData()
  }, [])

  const [editDiagnosis, setEditDiagnosis] = useState(null)
  const [deleteVisible, setDeleteVisible] = useState(false)

  const handleDeleteDiagnosis = () => {
    console.log(patientID, editDiagnosis,'patientID, editDiagnosis')
    deletePatientDiagnosis(patientID, editDiagnosis)
    setEditDiagnosis(null)
    setDeleteVisible(false)
  }
  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const informationData = patientDBData?.currentNote?.data?.information 
  

  console.log(patientDiagnosis,'patientDiagnosis in ts shell')
  return (
    <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '} `}>
      <CAccordion className="d-flex flex-column gap-2 ap" flush>
        {patientDiagnosis
          ?.sort((a, b) => a.localeCompare(b))
          ?.map((obj, index) => {
           const info = Array.isArray(informationData?.[obj])
  ? informationData[obj]
  : ["Provider Added"];
             console.log(" infoDetails---> " , info , noteStructureRef?.current)
            return (
              <CAccordionItem className="border" key={index} itemKey={index}>
                <CAccordionHeader>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-2 align-items-center">
                      <CTooltip content={info ? info.join(',') : 'Provider Added'}>
                        <Info size={16} />
                      </CTooltip>
                      <p className="m-0 p-0 " style={{ fontWeight: 'bolder', fontSize: '16px' }}>
                        {obj} ({diagnosisCode[obj?.trim()]})
                      </p>
                    </div>
                    <div className="p-2 mb-1">
                      <Trash2
                        size={20}
                        strokeWidth={1.5}
                        style={{ cursor: 'pointer', color: '#fc6357', fontWeight: 'bolder' }}
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          setEditDiagnosis(obj)
                          setDeleteVisible(true)
                        }}
                      />
                    </div>
                  </div>
                </CAccordionHeader>
                <CAccordionBody className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} p-4`}>
                  <CAccordion className="d-flex flex-column gap-2 treatmentAccordion">
                    <CAccordionItem className="border">
                      <CAccordionHeader>POA Baseline</CAccordionHeader>
                      <CAccordionBody>
                        <ProvidertsPoaBaseline diagnosisName={obj} patientID={patientID} patientTreatments={patientTreatments} noteID={noteID} noteStructureRef={noteStructureRef} patientDiagnosis={patientDiagnosis} noteCallType={noteCallType} />
                      </CAccordionBody>
                    </CAccordionItem>
                    <CAccordionItem className="border">
                      <CAccordionHeader>History of diagnosis</CAccordionHeader>
                      <CAccordionBody>
                        <ProviderHistoryofdiagnosisTs
                          noteStructureRef={noteStructureRef}
                          diagnosisName={obj}
                          isAllotedToProvider={isAllotedToProvider}
                          patientDiagnosis={patientDiagnosis}
                          diagnosis={patientDiagnosis}
                          noteID={noteID}
                          showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                          patientID={patientID}
                          noteCallType={noteCallType}
                        />
                      </CAccordionBody>
                    </CAccordionItem>

                    <CAccordionItem className="border">
                      <CAccordionHeader>Risk Factors</CAccordionHeader>
                      <CAccordionBody>
                        <ProviderRiskFactors
                          showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                          riskFactorWithKeyword={riskFactorWithKeyword}
                          hospitalRecords={hospitalRecords}
                          personalHistory={personalHistory}
                          diagnosisName={obj}
                          setSelectedRisks={setSelectedRisks}
                          selectedRisks={selectedRisks}
                          noteStructureRef={noteStructureRef}
                          patientData={patientData}
                          patientTreatments={patientTreatments}
                          noteID={noteID}
                          isAllotedToProvider={isAllotedToProvider}
                          patientDiagnosis={patientDiagnosis}
                          diagnosis={patientDiagnosis}
                          patientID={patientID}
                          changesInTreatmentShell={changesInTreatmentShell}
                          setChangesInTreatmentShell={setChangesInTreatmentShell}
                          loggedUserProvider={loggedUserProvider}
                          noteCallType={noteCallType}
                        />
                      </CAccordionBody>
                    </CAccordionItem>

                    {obj && obj === 'Cognitive Communication Deficit' && (
                      <CAccordionItem className="border">
                        <CAccordionHeader>BIMS Score</CAccordionHeader>
                        <CAccordionBody>
                          <div className="d-flex gap-2 align-items-center">
                            {bimsScoreData && bimsScoreData[obj] && bimsScoreData[obj]?.date && <p className="p-0 m-0">Date :{bimsScoreData[obj]?.date}</p>}
                            {bimsScoreData && bimsScoreData[obj] && bimsScoreData[obj]?.score && <p className="p-0 m-0">Score :{bimsScoreData[obj]?.score}</p>}
                          </div>
                        </CAccordionBody>
                      </CAccordionItem>
                    )}

                    {obj && obj === 'Cognitive Communication Deficit' && (
                      <CAccordionItem className="border">
                        <CAccordionHeader>Self Care Assessment</CAccordionHeader>
                        <CAccordionBody>
                          <div className="d-flex flex-column ">
                            {noteStructureRef.current &&
                              noteStructureRef.current.selfCareAssessment &&
                              noteStructureRef.current.selfCareAssessment[obj] &&
                              Object.entries(noteStructureRef.current.selfCareAssessment[obj])
                                .filter(([_, value]) => {
                                  if (value === null || value === undefined) return false
                                  if (typeof value === 'string') return value.trim() !== ''
                                  if (Array.isArray(value)) return value.length > 0
                                  if (typeof value === 'object') {
                                    const entries = Object.entries(value).filter(([_, v]) => v && (!Array.isArray(v) || v.length > 0) && (typeof v !== 'string' || v.trim() !== ''))
                                    return entries.length > 0
                                  }
                                  return true
                                })
                                .map(([key, value], idx) => (
                                  <div key={idx} className="d-flex flex-column mb-2">
                                    {typeof value === 'object' && value !== null && !Array.isArray(value) ? (
                                      (() => {
                                        const rendered = renderValue(value, key)
                                        return rendered ? (
                                          <>
                                            <b>{key}</b>
                                            <div>{rendered}</div>
                                          </>
                                        ) : null
                                      })()
                                    ) : (
                                      <div className="">
                                        <b style={{ textTransform: 'capitalize' }}>{key}:</b> <span>{Array.isArray(value) ? value.join(', ') : renderValue(value, key)}</span>
                                      </div>
                                    )}
                                  </div>
                                ))}
                          </div>
                        </CAccordionBody>
                      </CAccordionItem>
                    )}

                    {obj == 'Falls' && (
                      <div className=" ">
                        <ProviderMorseCodeTreatment
                          showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                          noteStructureRef={noteStructureRef}
                          diagnosisName={obj}
                          scoreType={'MorseScore'}
                          updateNoteStructure={updateNoteStructure}
                          setNoteRefTrigger={setNoteRefTrigger}
                          changesInTreatmentShell={changesInTreatmentShell}
                          setChangesInTreatmentShell={setChangesInTreatmentShell}
                          loggedUserProvider={loggedUserProvider}
                          noteCallType={noteCallType}
                        />
                      </div>
                    )}

                    {obj == 'Falls' && (
                      <div className=" ">
                        <ProviderMobilityTreatment showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} setNoteRefTrigger={setNoteRefTrigger}  noteCallType={noteCallType}/>
                      </div>
                    )}

                    <ProviderAlert noteStructureRef={noteStructureRef} diagnosisName={obj} changesInTreatmentShell={changesInTreatmentShell} setChangesInTreatmentShell={setChangesInTreatmentShell} loggedUserProvider={loggedUserProvider} patientID={patientID} noteCallType={noteCallType} />

                    <CAccordionItem className="border">
                      <CAccordionHeader>
                        {' '}
                        <span style={{ color: '#FFDF00' }}>Imaging</span>
                      </CAccordionHeader>
                      <CAccordionBody>
                        <Providertsimagings
                          MasterDiagnosisData={MasterDiagnosisData}
                          imaging={imaging}
                          imagingTypeList={imagingTypeList}
                          showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                          riskFactorWithKeyword={riskFactorWithKeyword}
                          hospitalRecords={hospitalRecords}
                          personalHistory={personalHistory}
                          setSelectedRisks={setSelectedRisks}
                          diagnosisName={obj}
                          noteStructureRef={noteStructureRef}
                          patientData={patientData}
                          patientTreatments={patientTreatments}
                          noteID={noteID}
                          isAllotedToProvider={isAllotedToProvider}
                          patientDiagnosis={patientDiagnosis}
                          diagnosis={patientDiagnosis}
                          patientID={patientID}
                          noteCallType={noteCallType}
                        />
                      </CAccordionBody>
                    </CAccordionItem>

                    <CAccordionItem className="border">
                      <CAccordionHeader>
                        <span style={{ color: '#FFDF00' }}>Labs</span>
                      </CAccordionHeader>
                      <CAccordionBody>
                        <ProviderPatientLabsTreatments
                          allLabs={allLabs}
                          setAllLabs={setAllLabs}
                          diagnosisAddedPinger={diagnosisAddedPinger}
                          MasterDiagnosisData={MasterDiagnosisData}
                          imaging={imaging}
                          imagingTypeList={imagingTypeList}
                          showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                          riskFactorWithKeyword={riskFactorWithKeyword}
                          hospitalRecords={hospitalRecords}
                          personalHistory={personalHistory}
                          setSelectedRisks={setSelectedRisks}
                          diagnosis={obj}
                          noteStructureRef={noteStructureRef}
                          patientData={patientData}
                          patientTreatments={patientTreatments}
                          noteID={noteID}
                          isAllotedToProvider={isAllotedToProvider}
                          patientDiagnosis={patientDiagnosis}
                          patientID={patientID}
                          noteCallType={noteCallType}
                        />
                      </CAccordionBody>
                    </CAccordionItem>

                    <ProviderTreatmentPatientDifferentDiagnosis
                      diagnosisName={obj}
                      isAllotedToProvider={isAllotedToProvider}
                      noteStructureRef={noteStructureRef}
                      changesInTreatmentShell={changesInTreatmentShell}
                      setChangesInTreatmentShell={setChangesInTreatmentShell}
                      loggedUserProvider={loggedUserProvider}
                      patientID={patientID}
                      noteCallType={noteCallType}
                    />

                    <PatientIncidentTreatments setAddedNewIncident={setAddedNewIncident} isAllotedToProvider={isAllotedToProvider} patientID={patientID} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj}  noteCallType={noteCallType}/>

                    <ProviderShellAssessment
                      patientDBData={patientDBData}
                      setPatientDBData={setPatientDBData}
                      saveTreatsShell={saveTreatsShell}
                      setActiveTabPatientInfo={setActiveTabPatientInfo}
                      addedChangesToAssessment={addedChangesToAssessment}
                      setAddedChangesToAssessment={setAddedChangesToAssessment}
                      patientID={patientID}
                      isAllotedToProvider={isAllotedToProvider}
                      showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                      MasterDiagnosisData={MasterDiagnosisData}
                      newImagingAdded={newImagingAdded}
                      newLabsAdded={newLabsAdded}
                      newmedsAdded={newmedsAdded}
                      patientTreatments={patientTreatments}
                      noteStructureRef={noteStructureRef}
                      masterMedications={masterMedications}
                      medicationList={medication}
                      diagnosisAddedPinger={diagnosisAddedPinger}
                      allLabs={allLabs}
                      labEntry={diagnosisLabMap[obj]}
                      imaging={imaging}
                      medsRemarks={getDiagnosisMedicationInRisk(obj)}
                      imagingTypeList={imagingTypeList}
                      diagnosisName={obj}
                      noteID={noteID}
                      changesInTreatmentShell={changesInTreatmentShell}
                      setChangesInTreatmentShell={setChangesInTreatmentShell}
                      loggedUserProvider={loggedUserProvider}
                       noteCallType={noteCallType}
                    />

                    <ProviderTreatmentPlans
                      saveTreatsShell={saveTreatsShell}
                      addedChangesToAssessment={addedChangesToAssessment}
                      setAddedChangesToAssessment={setAddedChangesToAssessment}
                      isAllotedToProvider={isAllotedToProvider}
                      patientID={patientID}
                      allTreamentStatements={allTreamentStatements}
                      setAllTreatmentStatements={setAllTreatmentStatements}
                      showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                      medicationList={medication}
                      masterMedications={masterMedications}
                      noteStructureRef={noteStructureRef}
                      diagnosisName={obj}
                      patientTreatments={patientTreatments}
                      allLabs={allLabs}
                      noteID={noteID}
                      patientDBData={patientDBData}
                      setPatientDBData={setPatientDBData}
                      noteCallType={noteCallType}
                    />
                  </CAccordion>
                </CAccordionBody>
              </CAccordionItem>
            )
          })}
      </CAccordion>
      {patientDiagnosis.length === 0 && (
        <div className="d-flex justify-content-center align-items-start text-muted" style={{ height: '50px' }}>
          <div
            style={{
              fontSize: '15px',
              fontWeight: '600px',
              color: 'gray',
            }}
          >
            No Data Available
          </div>
        </div>
      )}
      <CModal backdrop="static" visible={deleteVisible} onClose={() => setDeleteVisible(null)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
            height: '100px',
          }}
        >
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
          }}
        >
          <CButton
            onClick={() => {
              setDeleteVisible(null)
            }}
            variant="outline"
            color="secondary"
          >
            Close
          </CButton>
          <CButton variant="outline" onClick={() => handleDeleteDiagnosis()} color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default ProviderPatientTreatmentShell